import React, { useContext } from "react"
import { useFormContext } from "react-hook-form"

import Form from "src/components/Form"
import TaxRateDisplayInput from "src/components/TaxRateDisplayInput"

import { WizardContext } from "../../../WizardContextProvider"
import { CUSTOM_RATE_ID } from "../../../constants"

const RateTaxInput = () => {
  const {
    register,
    formState: { errors },
    watch,
    trigger,
  } = useFormContext()
  const { useNewTaxExperience, storageProduct } = useContext(WizardContext)
  const [rateId] = watch(["rate.id"])

  const isCustomRate = rateId === CUSTOM_RATE_ID

  if (useNewTaxExperience && isCustomRate) {
    return (
      <TaxRateDisplayInput
        combinedTaxRateDisplay={storageProduct?.combinedTaxRateDisplay || ""}
        taxes={storageProduct?.taxes?.map((tax) => ({
          id: tax.id,
          name: tax.name,
          rateDisplay: tax.rateDisplay,
        }))}
        label="Tax"
      />
    )
  }

  return (
    <div>
      <Form.Label htmlFor="trw-rate-tax">Tax</Form.Label>
      <Form.IconTextField
        icon="%"
        position="right"
        id="trw-rate-tax"
        type="text"
        inputMode="decimal"
        disabled={!isCustomRate}
        {...register("rate.tax_rate")}
        hasErrors={Boolean(errors?.rate?.tax_rate)}
        onBlur={() => trigger("rate.tax_rate")}
      />
      {errors?.rate?.tax_rate?.message && (
        <Form.Error>{errors.rate.tax_rate.message}</Form.Error>
      )}
    </div>
  )
}

export default RateTaxInput
